<script>
export default {}
</script>

<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://feelline.jp/" target="_blank">FEELLINE</a>
      <span class="ml-1"
        >Copyright &copy; A.T.WORKS, Inc. All Rights Reserved.</span
      >
    </div>
  </CFooter>
</template>
